import { render, staticRenderFns } from "./informationsTable.vue?vue&type=template&id=42668826&scoped=true"
import script from "./informationsTable.vue?vue&type=script&lang=js"
export * from "./informationsTable.vue?vue&type=script&lang=js"
import style0 from "./informationsTable.vue?vue&type=style&index=0&id=42668826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42668826",
  null
  
)

export default component.exports